"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var core_1 = require("@material-ui/core");
var useStyles = (0, core_1.makeStyles)(function (theme) {
    return (0, core_1.createStyles)({
        textButton: {
            paddingLeft: theme.spacing(0),
            paddingRight: theme.spacing(0),
            color: theme.palette.text.secondary,
            backgroundColor: 'transparent',
            transition: 'all .2s ease-in-out',
            '&:hover': {
                color: theme.palette.primary.dark,
                backgroundColor: 'transparent',
            },
        },
        tag: {
            display: 'contents',
        },
    });
});
var TextButton = function (_a) {
    var children = _a.children, className = _a.className, href = _a.href, disabled = _a.disabled, onClick = _a.onClick;
    var classes = useStyles();
    return (react_1.default.createElement("a", { className: classes.tag, href: href, target: "_blank", rel: "noopener noreferrer" },
        react_1.default.createElement(core_1.Button, { className: "".concat(className, " ").concat(classes.textButton), disabled: disabled, onClick: onClick, variant: "text", size: "large", disableFocusRipple: true, disableRipple: true }, children)));
};
TextButton.defaultProps = {
    className: '',
    href: undefined,
    disabled: undefined,
    onClick: undefined,
};
exports.default = TextButton;
